export default __webpack_public_path__ + "static/media/chbox1-norm.a4641ac8.svg";